module.exports = __webpack_public_path__ + "static/media/ekyc-banner-desktop.3ee616e3.png";